/* eslint-disable react/prop-types */
import {InputContainer, InputPure} from '@modifi/ui'
import PropTypes from 'prop-types'
import React from 'react'
import NumberFormat from 'react-number-format'

const Input = props => <InputPure {...props} />

const NumberFormatInput = ({onChange, ...props}) => (
  <NumberFormat
    customInput={Input}
    onValueChange={({floatValue, value}) => {
      // https://github.com/s-yadav/react-number-format/issues/317
      // onValueChange will be triggered on every time props change (even without no triggered event)
      // temp. workaround for this is to check if the actual value has been changed
      // make sure to set the value / floatValue based on the initial state format
      if (typeof props.value === 'string') {
        if (props.value !== value) {
          onChange({value})
        }
      } else if (parseFloat(props.value) !== floatValue) {
        onChange({value: floatValue})
      }
    }}
    {...props}
  />
)

NumberFormatInput.propTypes = {
  onChange: PropTypes.func.isRequired,
}

const NumberFormatInputWithContainer = props => (
  <InputContainer inputComponent={NumberFormatInput} {...props} />
)

export default NumberFormatInputWithContainer
